/**
 * Shared type scale + accent for the in-call scribe panel.
 *
 * FIVE sizes only (9.5 / 10.5 / 12 / 14 / 20px) cover the whole surface. Use a
 * semantic token instead of a raw `text-[Npx]` so the panel can't drift back to
 * the 13-size sprawl. Weight + case are baked in per role; append color and
 * `leading-*` classes at the call site.
 */
export const scribeText = {
  /** 9.5px — timestamps, chat badge, PiP initials, tiny captions. */
  micro: 'text-[9.5px]',
  /** 10.5px bold UPPER — status eyebrows: TRANSCRIBING / SCRIBE READY / speaker / section labels. */
  eyebrow: 'text-[10.5px] font-bold uppercase tracking-[0.06em]',
  /** 10.5px — status-bar pills, subtext, secondary meta (weight set at call site). */
  meta: 'text-[10.5px]',
  /** 12px — body copy, transcript captions, descriptions. */
  body: 'text-[12px]',
  /** 12px semibold — buttons, names, inline labels. */
  label: 'text-[12px] font-semibold',
  /** 14px bold — dialog headings. */
  title: 'text-[14px] font-bold',
  /** 14px bold tabular — the MM:SS call timer. */
  timer: 'text-[14px] font-bold tabular-nums',
  /** 20px bold — large avatar initials. */
  display: 'text-[20px] font-bold',
} as const

/**
 * Call-action accent (warm coral). Matches the ui-designs prototype and is
 * intentionally distinct from the app brand blue (#316dab). Prefer this token
 * for new code; legacy hardcodes of `#e8624a` remain in ChatDrawer,
 * InterruptedResumePanel, ConversationTooShortModal, RecentPatientsBar, and
 * PatientChartActionBar.
 */
export const SCRIBE_ACCENT = '#e8624a'
